// @flow

/**
 * selectByStoreKey
 *
 * @param {Object} state
 * @returns {?Object}
 */
export function selectByStoreKey(storeKey: string) {
  return function selector(state: Object): ?Object {
    return state[storeKey];
  };
}
